import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "section-tab-view" }
const _hoisted_2 = {
  class: "section-tab-view__nav",
  role: "tablist",
  "aria-label": "Section tabs"
}
const _hoisted_3 = ["aria-selected", "onClick"]
const _hoisted_4 = { class: "section-tab-view__actions" }
const _hoisted_5 = { class: "section-tab-view__body" }

export interface SectionTab {
    id: string
    label: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionTabView',
  props: {
    tabs: {},
    activeTabId: {}
  },
  emits: ["tab-change"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */

const props = __props;

const emit = __emit;

const isActive = (tab: SectionTab) => props.activeTabId === tab.id;

const navigate = (tab: SectionTab) => {
    if (tab.id === props.activeTabId) {
        return;
    }

    emit('tab-change', tab.id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.id,
          class: _normalizeClass(["section-tab-view__tab", { 'section-tab-view__tab--active': isActive(tab) }]),
          role: "tab",
          type: "button",
          "aria-selected": isActive(tab),
          onClick: ($event: any) => (navigate(tab))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "actions")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})